"use client";
import * as React from 'react';
import { ContentText } from '../../ContentText/ContentText.web.js';
import { useTheme } from '../../utils/theming/useTheme.js';

var ThankYouPage = function ThankYouPage(_ref) {
  var labels = _ref.labels;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(ContentText, {
    "data-testid": "elemental-NPS-ThankYouPage-Description",
    color: theme.nps.web.textColors.description
  }, labels.thankYou);
};

export { ThankYouPage };
